
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const DatePickerTimeslot = (props: any) => {

  let minDate = ((props.minDate) ? new Date(props.minDate) : null);
  let maxDate = ((props.maxDate) ? new Date(props.maxDate) : null);
  let highlights = props.highlights || []
  const highlightWithRanges = [
    {
      "dayHaveTimeslot": highlights.map((highlight: string) => new Date(highlight)),
    }
  ];
  const onMonthChange = (day: Date) => {
    if (typeof props.setMonthShow === "function") {
      props.setMonthShow(day)
    }
  }

  let date = props.date ?? new Date();
  return (
    <>
      <div className="datePickerTimeslot">
        <DatePicker
          minDate={minDate}
          maxDate={maxDate}
          onMonthChange={onMonthChange}
          highlightDates={highlightWithRanges}
          selected={date} onChange={(date: Date) => props.handleChange(date)} inline />
      </div>
    </>
  )
}

export default DatePickerTimeslot
